var GetWorldX = function (tileX, tileY) {
    return this.getWorldXY(tileX, tileY, true).x;
}

export default GetWorldX;